import React from 'react';

import Card from "../../../card";
import { GroupItem, NameValuePair } from '../models';
import OrderGroupItem from './order-group-item';
import OrderLineItem from './order-line-item';
import { OrderGroupContainer } from './style';
import PaymentSubtotal from './subtotal-item';
import TotalItem from './total-item';

type OrderInfoSectionProps = {
    products: GroupItem[];
    payment: { itemEntriesEn: NameValuePair[], itemEntriesFr: NameValuePair[], subTotalEntriesEn: NameValuePair[], subTotalEntriesFr: NameValuePair[], totalEntriesEn: NameValuePair[], totalEntriesFr: NameValuePair[]};
    className?: string;
    title: string;
    isEng?: boolean;
};

export default function OrderInfoSection({
    products,
    payment,
    className,
    title,
    isEng  // cannot have default value, null means French
}: OrderInfoSectionProps) {
    const renderGroupItem = ({
        index,
        productDetailEntries
    }: {
        index: number;
        productDetailEntries: NameValuePair[];
    }) => {
        return <OrderGroupItem key={index} orderGroupItems={productDetailEntries} />;
    };

    const renderLineItem = ({
        key,
        itemDetailEntries,
        htmlElement
    }: {
        key?: number | string;
        itemDetailEntries: NameValuePair[];
        htmlElement: React.JSX.Element;
    }) => {
        const pageContent = <>
            <OrderLineItem key={key} lineItems={itemDetailEntries}/>
            {htmlElement && htmlElement}
        </>;
        return pageContent;
    };

    const renderSubtotalEntries = (subtotals: NameValuePair[]) => {
        const html = [];
        let index = 0;
        subtotals.forEach(({name, value}) => {
            html.push(
                <>
                    <PaymentSubtotal
                        key={index++}
                        item={name}
                        amount={value}
                        bold={index == 1}
                    />
                </>);
        });
        return html;
    };

    const renderTotalEntries = (totals: NameValuePair[]) => {
        const html = [];
        let index = 0;
        totals.forEach(({name, value}) => {
            html.push(
                <>
                    <TotalItem
                        key={index++}
                        item={name}
                        amount={value}
                    />
                </>);
        });
        return html;
    };

    return (
        <Card
            className={className}
            title={title}
            content={
                <>
                    {products?.map(({ productDetailEntriesEn, productDetailEntriesFr, items }, index) => (
                        <>
                            <OrderGroupContainer key={`${index}-group`}>
                                {renderGroupItem({ 
                                    index, 
                                    productDetailEntries: isEng ? productDetailEntriesEn : productDetailEntriesFr
                                })}
                                {items.map(({ itemDetailEntriesEn, itemDetailEntriesFr, htmlElement }) =>
                                    renderLineItem({
                                        key: index,
                                        itemDetailEntries: isEng ? itemDetailEntriesEn : itemDetailEntriesFr,
                                        htmlElement
                                    })
                                )}
                            </OrderGroupContainer>
                        </>
                    ))}
                    <>
                        {payment?.subTotalEntriesEn?.length && renderSubtotalEntries(isEng ? payment.subTotalEntriesEn : payment.subTotalEntriesFr)}
                    </>
                    <>
                        {payment?.totalEntriesEn ?.length && renderTotalEntries(isEng ? payment.totalEntriesEn : payment.totalEntriesFr)}
                    </>
                </>
            }
        />
    );
}
